"use strict";
/**
 * Created by Marvin on 28.03.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
// @ts-ignore
var query_string_1 = __importDefault(require("query-string"));
var initialValuesFromURL = function (arrayKey) {
    try {
        var result = query_string_1["default"].parse(decodeURI(location.search.substr(1)));
        var formResult = JSON.parse(result.form);
        return formResult[arrayKey];
    }
    catch (e) {
        return {};
    }
};
exports["default"] = initialValuesFromURL;
